import { ChartBoxPlusOutlineIcon } from './ChartBoxPlusOutlineIcon';

/**
 * author: Google
 * id 2F2AA4D1-DB33-4B54-8052-2A2EFCE59168
 * name chart-box-plus-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-box-plus-outline.svg
 * tags
 * - Math 
 */
export const WidgetBoxPlusOutlineIcon = ChartBoxPlusOutlineIcon;
export default WidgetBoxPlusOutlineIcon